import isEqual from 'lodash/isEqual';
import { sleep } from '../subscriptions/api';
import { QueryClient } from 'react-query';
import { Moment } from '../../components/Moments/types';

export const startMomentsApplicationsRefetchBackoff = async ({
  queryClient,
  subscriptionId,
}: {
  queryClient: QueryClient;
  subscriptionId: string;
}) => {
  const queryKey = ['moments', subscriptionId];
  const currentMoments = queryClient.getQueryData<Moment>(queryKey);
  let newMoments = currentMoments;

  let interval = 1500;

  while (isEqual(newMoments, currentMoments) && interval <= 24000) {
    await sleep(interval);
    interval = interval * 2;
    newMoments = await queryClient.fetchQuery(queryKey);
  }
};
